/**
 * Ekran bazli yetki kataloğu (Parameters / YETKILER, backend
 * bootstrap-data.json + SeedPermissionCatalogAndPreserveRoleBehavior
 * migration'iyla BIREBIR ayni kimlikler).
 *
 * SideMenu.tsx onceden bu ekranlari sabit ROL kimlikleriyle
 * (AuthorizationIds.Roles.X) gizliyordu -- roller sabit oldugu icin
 * musteri yeni bir rol olusturup ona ozel bir ekran seti veremiyordu.
 * Artik gate'ler bu YETKI kimlikleriyle (useIsInPermission) kontrol
 * ediliyor; hangi rolun hangi yetkiye sahip oldugu artik veri (Roller ve
 * Yetkiler ekrani), koda gomulu degil.
 */
export const Permissions = {
    PerfCardsAccess: '0398f5af-90fb-463e-b51b-2a482d126a70',
    PerfCardsTeamOkr: '44238068-77e7-45e5-bb18-9acfff410d51',
    PerfCardsAllOkr: '445b53f6-08a0-41d5-8f57-47a9abb4c596',
    PerfCardsTeamKpi: '50b89283-ce7d-4e0c-9702-2b9df64908d3',
    PerfCardsAllKpi: '8ca4dd0c-9979-4e2c-987a-b558cc695427',
    PerfCardsTeamCompetency: 'f2cdfed4-8aa8-4ab6-95bf-2ad647bf2a8f',

    OneOnOneAccess: 'e7c6afa7-9f64-4611-86db-ec91be9ef41c',
    OneOnOneTeam: 'e39b04f0-d860-442d-a480-9f0ab3fc35ea',
    OneOnOneManager: '1f3524c7-c223-4418-b4d1-27f97036ae40',
    OneOnOneMyTeams: '30aa27a4-48a4-48b6-8a9e-d36091a54e97',

    FeedbackAccess: '8e8c9e0c-66ec-44cc-8989-b459b66b3f8d',
    FeedbackTeam: '353a6e3d-aee6-4ea5-841d-1d1bfdfe2ec3',

    EvaluationManager: '4b525046-4f48-463f-81f3-748017192c22',
    EvaluationCalibration: '19f7d8b4-3178-4426-acf8-cca38c81d8f1',
    EvaluationMyResults: '43a46dae-da0f-4592-9651-89f32ce1a9ac',

    ReportsAccess: '17f7133d-3bd4-4573-ba5f-34dfa797e0da',

    AdminAccess: 'c8c06c44-01c8-4b44-8499-1195d62b5a22',
    AdminPeriod: '39fb13c8-29c4-4e68-afec-623cebdcecd2',
    AdminTargetAudience: '3c81595e-fd9a-4d93-9be7-558961225241',
    AdminScale: '68469f7a-c8e2-492e-9f4c-282ae36f5860',
    AdminPerformanceSystems: '29d5311c-a2fb-440b-98be-4a8b5b1f8c08',
    AdminStrategicOkrEntry: '4559b417-fc4e-4397-9e0a-71b67f3ca79b',
    AdminDepartmentOkrEntry: '60b2a37e-2853-429f-9335-ad1acc278396',
    AdminCorporateGoalCard: 'c5b01868-2d2a-45b4-8d1e-4f9b20a51ed4',
    AdminDepartmentGoalCard: '439cf288-6ff6-40ea-87ec-f9218b2ca1e4',
    AdminCorporateGoalResult: 'a75e0939-ba72-43ff-a39b-7861d569e04e',
    AdminDepartmentGoalResult: '413b5c08-084d-4feb-ac5f-203cf3e24ecb',
    AdminIndividualKpiCards: '52115c5f-43ff-49ac-b6cb-c076a2cc6e1e',
    AdminCompetencyEntry: '5b7b8cb4-5435-4444-b20d-e42e2e8a05d4',
    AdminCompetencyRoleEntry: 'eee1e876-eeca-4eba-bdda-bda82ebd040e',
    AdminPerformanceCardsCreation: '6bef9116-ca12-4fc9-aac3-14cb747f3bcf',
    AdminDashboardScreens: 'ced24a14-9a68-420c-857a-dc2b85d783c3',
    AdminKpiPool: '1f028251-014a-44f0-accb-69f35d051bc3',
    AdminMeetingSchedule: '90761a4b-d814-4f2a-a00d-d9e21e04e4ea',
    AdminNudgingEmails: '54b5450a-4256-4f36-a506-bb8361ebdb25',
    AdminRolesPermissions: '904dcbdf-01d7-4fd9-88c5-3587de39d355',
    AdminUserRoleDefinitions: '20364117-98f1-4d62-b3ad-367e5e97fdda',
    AdminManagerEvaluationSettings: 'ad5b3e1c-2af4-4de9-b60a-6a1ded885368',
    AdminParameters: 'c63efbf2-5dc1-4c3c-adc8-74f5f64a2e97',
    AdminUsers: 'db79f5b2-d7cd-4d2b-805b-d4609e4049f3',
} as const;

export const AuthorizationIds = {
    Roles: {
        SuperAdmin: '552edba2-c1f6-4067-b800-b1c5ac6690ae',
        Admin: "c229c8ec-83e5-4454-a409-07bce2f36ef5",
        Personel: "e234a812-35b5-4858-97f5-e034d704a987",
        Manager: "354bab90-dd8d-4b37-8537-be4bc6f8c776",
        CalibrationManager: "2972f23f-13cd-4824-a8f2-9b517e8816a3"
    },
    List: [
        {name: 'Super Admin', id: '552edba2-c1f6-4067-b800-b1c5ac6690ae'},
        {name: 'Admin', id: 'c229c8ec-83e5-4454-a409-07bce2f36ef5'},
        {name: 'Kalibrasyon Yöneticisi', id: '2972f23f-13cd-4824-a8f2-9b517e8816a3'},
        {name: 'Yönetici', id: '354bab90-dd8d-4b37-8537-be4bc6f8c776'},
        {name: 'Personel', id: 'e234a812-35b5-4858-97f5-e034d704a987'}
    ]
}
   
// Sabit 5 sistem rolu -- ozel (sonradan olusturulan) rolleri bundan ayirt
// etmek icin kullanilir (bkz. GetHighestAuthOrder).
const SYSTEM_ROLE_IDS: string[] = [
    AuthorizationIds.Roles.SuperAdmin,
    AuthorizationIds.Roles.Admin,
    AuthorizationIds.Roles.CalibrationManager,
    AuthorizationIds.Roles.Manager,
    AuthorizationIds.Roles.Personel,
];

/**
 * Kullanicinin dashboard'unu belirlemek icin "en yuksek" rolunu secer.
 *
 * Oncelik sirasi 5 sistem rolu icin AYNEN korunuyor (mevcut kurulumlarda
 * davranis degismiyor). Kullanicinin YALNIZCA ozel bir rolu varsa (hicbir
 * sistem rolu eslesmiyorsa) -- onceden bu durumda sessizce Personel'in
 * dashboard'una duseyordu, kullanicinin kendi rolu icin ayrica tanimlanmis
 * bir dashboard olsa bile hic gorulmuyordu. Artik ilk ozel rol kullaniliyor;
 * "Dashboard Ekranlari" ekranindan o rol icin bir duzen tanimlanmamissa
 * bos bir grid gorunur (Dashboard.tsx'in zaten sahip oldugu bos durum).
 */
export const GetHighestAuthOrder = (roles: string[]) => {
    var isSuperAdmin = roles.includes(AuthorizationIds.Roles.SuperAdmin);
    var isAdmin = roles.includes(AuthorizationIds.Roles.Admin);
    var isCalibrationManager = roles.includes(AuthorizationIds.Roles.CalibrationManager);
    var isManager = roles.includes(AuthorizationIds.Roles.Manager);
    var isPersonel = roles.includes(AuthorizationIds.Roles.Personel);

    //! This code order is important
    if (isSuperAdmin) {
        return AuthorizationIds.Roles.SuperAdmin
    }
    if (isAdmin) {
        return AuthorizationIds.Roles.Admin
    }
    if (isCalibrationManager) {
        return AuthorizationIds.Roles.CalibrationManager
    }
    if (isManager) {
        return AuthorizationIds.Roles.Manager
    }
    if (isPersonel) {
        return AuthorizationIds.Roles.Personel
    }

    var customRole = roles.find(r => !SYSTEM_ROLE_IDS.includes(r));
    if (customRole) {
        return customRole;
    }

    //Else (hic rolu yok)
    return AuthorizationIds.Roles.Personel
}
